// extracted by mini-css-extract-plugin
export var container = "_kl-0";
export var dotAnimation = "_kl-2";
export var dotsLoading = "_kl-1";